export default "__VITE_ASSET__BKGo70qK__"